// 浏览器兼容策略入口（由 next.config.js webpack 注入到客户端入口最前执行）：
// 业务代码一律直接使用原生 API，超出 browserslist 声明下限运行时（ES2020）的新版内置方法
// 统一在此注入 core-js 定向 polyfill，不散落在业务代码里手工改写。
//
// 与 tsconfig.json lib 的一一对应（新增时两处同步改）：
//   ES2022.Array ↔ core-js/actual/array/at
//   ES2023.Array ↔ core-js/actual/array/find-last、core-js/actual/array/find-last-index
// 提升支持线后：删除对应 import 并同步移除 lib 中的对应条目。
import 'core-js/actual/array/at'
import 'core-js/actual/array/find-last'
import 'core-js/actual/array/find-last-index'
